// Components
import CustomerAssurance from "@/components/CustomerAssurance/CustomerAssurance";
import { FormWrapper } from "@/components/Forms/FormWrapper";
import FeaturesList from "@/components/FeaturesList/FeaturesList";
import OrderSummary from "@/components/OrderSummary/OrderSummary";
import ProductList from "@/components/ProductList/ProductList";
// Store
import { useTemplateStore } from "@/zustand/templateStore";
// Other
import type { JSX } from "react";

const SECTION_COMPONENTS: Record<string, JSX.Element> = {
  features: <FeaturesList />,
  assurance: <CustomerAssurance />,
  productlist: <ProductList />,
  form: <FormWrapper />,
  summary: <OrderSummary />,
};

export default function Checkout() {
  const { orderSummary, sectionPositions } = useTemplateStore();

  const useCustom = sectionPositions?.use_custom_section_positions;
  const positions = sectionPositions?.custom_positions ?? [];

  // Default layout
  if (!useCustom) {
    return (
      <>
        {!orderSummary?.order_summary_version && (
          <OrderSummary className="md:hidden" />
        )}

        <main
          className={`max-w-body mx-auto mb-6 flex flex-col gap-6 px-4 md:mb-10 md:flex-row ${
            orderSummary?.order_summary_version ? "mt-6" : ""
          } md:mt-10`}
        >
          <div className="flex flex-1 flex-col gap-6">
            <FeaturesList />
            <ProductList />
            <CustomerAssurance className="hidden md:flex" />
          </div>

          <div className="flex flex-1 flex-col gap-6">
            {!orderSummary?.order_summary_version && (
              <OrderSummary className="hidden md:flex" />
            )}
            <FormWrapper />
            {orderSummary?.order_summary_version && <OrderSummary />}
            <CustomerAssurance className="md:hidden" />
          </div>
        </main>
      </>
    );
  }

  // Custom Layout
  const sortByPosition = (a: any, b: any) =>
    Number(a.position) - Number(b.position);

  const left = positions
    .filter((p: any) => p.column === "left")
    .sort(sortByPosition);

  const right = positions
    .filter((p: any) => p.column === "right")
    .sort(sortByPosition);

  const mobileItems = [...positions].sort(
    (a: any, b: any) => Number(a.mobile_position) - Number(b.mobile_position),
  );

  return (
    <main className="max-w-body mx-auto mt-6 mb-6 flex flex-col gap-6 px-4 md:mt-10 md:mb-10 md:flex-row">
      {/* Mobile */}
      <div className="flex flex-col gap-6 md:hidden">
        {mobileItems.map((item: any, index: number) => (
          <div key={`mobile-${item.section}-${index}`}>
            {SECTION_COMPONENTS[item.section]}
          </div>
        ))}
      </div>

      {/* Desktop */}
      <div className="hidden w-full gap-6 md:flex">
        <div className="flex flex-1 flex-col gap-6">
          {left.map((item: any, index: number) => (
            <div key={`left-${item.section}-${index}`}>
              {SECTION_COMPONENTS[item.section]}
            </div>
          ))}
        </div>

        <div className="flex flex-1 flex-col gap-6">
          {right.map((item: any, index: number) => (
            <div key={`right-${item.section}-${index}`}>
              {SECTION_COMPONENTS[item.section]}
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
